import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=3b300edf&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=ts"
export * from "./Resources.vue?vue&type=script&lang=ts"
import style0 from "./Resources.vue?vue&type=style&index=0&id=3b300edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b300edf",
  null
  
)

export default component.exports